import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Button } from 'react-bootstrap';
import TourManager from '../TourManager';
import TourManagerModal from '../TourManagerModalContainer';
import { fromNow } from '../../../../core/date';


function hasLength(value) {
  if (Object.prototype.hasOwnProperty.call(value, 'length')) {
    return value.length !== 0;
  }
  return false;
}

function formatSentOn(sentOn) {
  if (sentOn) {
    return (<p>Last sent: {fromNow(sentOn)}</p>);
  }
  return (<p>Click send to invite collaborators to tour.</p>);
}

class TourManagerWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSend = this.handleSend.bind(this);
  }
  close() {
    this.setState({ showModal: false });
  }
  open() {
    this.setState({ showModal: true });
  }

  handleSend(e) {
    e.preventDefault();
    this.props.sendToTourManager(this.props.tour.id, {});
  }

  buildToolbar(readOnly, state, managers) {
    if (readOnly) {
      return null;
    }
    if (state === 'AR') {
      return null;
    }
    if (hasLength(managers)) {
      return (
        <p>
          <Button bsStyle="info" onClick={this.open}>
            <i className="fa fa-share-alt" /> Share
          </Button>
          <Button bsStyle="info" onClick={this.handleSend}>
            <i className="fa fa-envelope" /> Send
          </Button>
        </p>
      );
    }
    return (
      <p>
        <Button bsStyle="info" onClick={this.open}>
          <i className="fa fa-share-alt" /> Share
        </Button>
      </p>
    );
  }
  formatManagers(managers) {
    const managerList = [];
    managers.forEach((tm) => {
      managerList.push(
        <TourManager
          key={tm.id}
          tourId={this.props.tour.id}
          tourManager={tm}
          sendToTourManager={this.props.sendToTourManager}
          removeTourManager={this.props.removeTourManager}
          readOnly={this.props.readOnly}
        />,
      );
    });
    return managerList;
  }
  render() {
    let roster;

    const sentOn = formatSentOn(this.props.tour.sent_to_manager);

    if (hasLength(this.props.tour.managers)) {
      const managers = this.formatManagers(
        this.props.tour.managers,
      );
      roster = (
        <div>
          {managers}
          {sentOn}
        </div>);
    } else {
      roster = (
        <p>Share with clients to give them access to hotel selections.</p>
      );
    }
    const toolbar = this.buildToolbar(
      this.props.readOnly,
      this.props.tour.state,
      this.props.tour.managers,
    );

    return (
      <div className="col-sm-3">
        <Panel header="Clients">
          {roster}
          {toolbar}
        </Panel>
        {this.state.showModal && (
          <TourManagerModal
            show={this.state.showModal}
            onClose={this.close}
            readOnly={this.props.readOnly}
            requestTourManagers={this.props.requestTourManagers}
            tourManagers={this.props.tourManagers}
          />
        )}
      </div>
    );
  }
}
TourManagerWidget.propTypes = {
  tour: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export default TourManagerWidget;



// WEBPACK FOOTER //
// src/routes/tours/components/widgets/TourManagerWidget.js